import styled, { css } from 'styled-components';

export const CourseCard = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.v2.colors.white.primary};
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    font-size: 16px;
    font-family: ${theme.v2.font.family.primary};
    min-height: 337px;
    justify-content: space-between;
    left: 0px;
    overflow: hidden;
  `}
`;

export const Image = styled.img``;

export const ImageWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: start;
  flex-direction: column;
`;

export const TagWrapper = styled.div`
  position: absolute;
  margin: 2px;
  bottom: 0;
`;

export const CourseTitle = styled.p`
  ${({ theme }) => css`
    font-weight: ${theme.v2.font.weights.medium};
    margin: 16px 16px 0;
    text-align: center;
  `};
`;

export const DetailsWrapper = styled.div`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    display: flex;
    flex-direction: column;
    gap: 16px;
    justify-content: center;
    padding: 16px 16px 24px;
  `};
`;

export const RatingStars = styled.div`
  ${({ theme }) => css`
    gap: 6px;
    color: ${theme.v2.colors.feedback.attentionPure};
    display: flex;
    justify-content: center;
  `};
`;
